import dynamic from 'next/dynamic';

const MyEbooks = dynamic(() => import(/* webpackChunkName: "pbKpMyEbooks" */ './MyEbooks'));

const pageBuilderComponents = {
  kp_myebooks: MyEbooks
};

export default pageBuilderComponents;
